module.exports = __webpack_public_path__ + "img/character-body.256e3515.png";